import { AgChartOptions } from "@ag-grid-community/core";
import { Box, Center } from "@chakra-ui/react";
import { AgChartsReact } from "ag-charts-react";
import React from "react";
import { LibBoxDNASpinner } from "../../../components/lib";
import { Status } from "../../../components/shared/Status";

import { useReadPublicChart } from "../../../services/api/charts/mutations/useReadPublicChart";
import { getPublicCasesCountOptions } from "../utils/getPublicCasesCountOptions";

interface IProps {
  registryAbbr: string;
}

const CaseCountChart = ({ registryAbbr }: IProps) => {
  const [casesCountOptions, setCasesCountOptions] =
    React.useState<AgChartOptions>({});

  const {
    data: dataCharts,
    isLoading,
    isError,
  } = useReadPublicChart({
    registryAbbr,
    chartName: "case_count",
  });

  React.useEffect(() => {
    const resCaseCountOptionsUpdate = getPublicCasesCountOptions(dataCharts);

    if (resCaseCountOptionsUpdate) {
      setCasesCountOptions(resCaseCountOptionsUpdate);
    }
  }, [dataCharts]);

  return (
    <Box h="full" w="full">
      {isLoading && (
        <Center h="full">
          <LibBoxDNASpinner />
        </Center>
      )}
      {isError && (
        <Center h="full">
          <Box>
            <Status.IsError></Status.IsError>
          </Box>
        </Center>
      )}
      {!isLoading && dataCharts && (
        <AgChartsReact options={casesCountOptions} />
      )}
    </Box>
  );
};

export default CaseCountChart;
